// OpenTelemetry web tracer — side-effect import. When enabled, initializes
// the OTel SDK with auto-instrumentation for document-load, fetch, and XHR.
// MUST be imported (and therefore execute) before React renders so the
// initial page-load span is captured.
//
// Opt-in: this module is a complete no-op unless VITE_OTEL_ENABLED === "true".
// The exporter targets an OTLP/HTTP collector (e.g. the one published by
// Bricklynk-LYNK's docker-compose) whose URL comes from VITE_OTEL_ENDPOINT.
// In production (admin.bricklynk.io) no collector exists, so OTel is left
// off by default — leaving it on crashed the app on load. To re-enable for
// local dev, set both VITE_OTEL_ENABLED=true and VITE_OTEL_ENDPOINT
// (e.g. http://localhost:4318/v1/traces) in .env.local.
//
// Service name is hard-coded: it identifies this portal in SigNoz/Sentry
// dashboards and never varies by environment.

import { WebTracerProvider, BatchSpanProcessor } from '@opentelemetry/sdk-trace-web';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';

const otelEnabled = import.meta.env.VITE_OTEL_ENABLED === 'true';
const otelEndpoint = import.meta.env.VITE_OTEL_ENDPOINT as string | undefined;

if (otelEnabled) {
  try {
    if (!otelEndpoint) {
      console.warn(
        '[otel] VITE_OTEL_ENABLED is "true" but VITE_OTEL_ENDPOINT is unset; skipping tracer init',
      );
    } else {
      const provider = new WebTracerProvider({
        resource: resourceFromAttributes({
          'service.name': 'bricklynk-admin-portal',
        }),
        spanProcessors: [
          new BatchSpanProcessor(
            new OTLPTraceExporter({ url: otelEndpoint }),
          ),
        ],
      });
      provider.register();

      registerInstrumentations({
        instrumentations: [getWebAutoInstrumentations()],
      });
    }
  } catch (err) {
    // Never let observability setup take down the app.
    console.warn('[otel] initialization failed; tracing disabled', err);
  }
}
